import type React from 'react';

import type { Movement } from 'src/app/pages/petitionDetails/shared/types';

import { usePetitionDetails } from '../../hooks/petitionDetails/petitionDetails';

import { MovementCard } from './components/MovementCard';

type Props = {
	movement: Movement;
	alwaysExpanded?: boolean;
};

export const MovementContainer: React.FC<Props> = (props) => {
	const { id: petitionId } = usePetitionDetails();
	return <MovementCard petitionId={petitionId} {...props} />;
};
